import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class JenisMitra {
  index() {
    return Axios.get(API_URL + 'jenismitra-list/');
  }

  show(jenismitra) {
    return Axios.get(API_URL + `jenismitra/${jenismitra}`);
  }
}

export default new JenisMitra();



// WEBPACK FOOTER //
// ./src/api/jenismitra.js